import type { RootState } from 'react-redux';

import { createAsyncThunk } from '@reduxjs/toolkit';
import { Location } from 'promotions/core/universalRouter/types';

const toLocationObject = (to: Location | string) => {
  if (typeof to === 'string') {
    const [pathname, search] = to.split('?');
    return new Location({ pathname, search });
  }
  return to;
};

type ThunkExtra = {
  history?: any;
  req?: any;
  res?: any;
  apiClient?: any;
};

export const pushLocation = createAsyncThunk<
  void,
  Location | string,
  { state: RootState; extra: ThunkExtra }
>('router/pushLocation', async (to, { getState, extra }) => {
  const { history, res } = extra;
  const { baseUrl } = (getState() as any).router;
  const locationTo = toLocationObject(to);

  if (history) {
    history.push(locationTo);
  } else if (res) {
    let path = locationTo.pathname || '/';
    if (locationTo.search) path = path + '?' + locationTo.search;
    res.redirect(baseUrl + path);
  }
});
